export const allocationStakeholdersTableConfig = [
  {
    field: 'slNo',
    header: 'Sl. No',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'vertical_name',
    header: 'Vertical Name',
    type: 'string',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 2,
    menuItems: [],
  },
  {
    field: 'resource_role_name',
    header: 'Role',
    type: 'string',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 3,
    menuItems: [],
  },
  {
    field: 'resource_emp_num',
    header: 'Employee ID',
    type: 'string',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 4,
    menuItems: [],
  },
  {
    field: 'resource_emp_name',
    header: 'Employee Name',
    type: 'string',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 5,
    menuItems: [],
  },
  {
    field: 'status',
    header: 'Status',
    type: 'string',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 6,
    menuItems: [],
  },
  {
    field: 'action',
    header: 'Action',
    className: 'allocation-stakeholders-action-column',
    headerClassName: 'allocation-stakeholders-action-column',
    width: 120,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 7,
    menuItems: [],
  },
];

